import { BasicGraphOnEdges } from './basicGraphOnEdges';
export class BasicGraph extends BasicGraphOnEdges {
    constructor(edges, numberOfVerts) {
        super();
        this.SetEdges(edges, numberOfVerts);
    }
}
//# sourceMappingURL=BasicGraph.js.map